import { executeRequest, HTTP_METHODS } from "@/common/utils/http/httpClient";

export async function getNewsFeed() {
  return await executeRequest(
    {
      url: `/assets/mocks/newsFeed.json`,
      method: HTTP_METHODS.GET
    },
    false
  );
}
